import { FormApi } from '@platform/formiojs-react';
import { useState } from 'react';

export type UseFormApi = [FormApi | undefined, (formApi: FormApi) => void];

export function useFormApi(): UseFormApi {
    const [formApi, setFormApi] = useState<FormApi>();
    return [formApi, setFormApi];
}
